import { transport } from '@opengov/transport';
import { ProgressTrackerSettingType } from '../types';

/**
 * Fetches ProgressTracker settings for a given entityId
 * @param entityId - The entity Id to fetch settings for
 * @returns Promise<ProgressTrackerSetting[]> - Array of ProgressTracker settings
 */
export const fetchProgressTrackerSettings = async (
    entityId: number,
): Promise<ProgressTrackerSettingType[]> => {
    if (!entityId) {
        console.warn('No entityUuid provided for ProgressTracker settings');
        return [];
    }

    const baseUrl = `/api/stories/v1/progressTrackerSettings/${entityId}`;

    try {
        const result = await transport
            .url(baseUrl)
            .get()
            .json();
        return result.data as ProgressTrackerSettingType[];
    } catch (error: unknown) {
        const errorMessage = error instanceof Error ? error.message : String(error);
        throw new Error(errorMessage || 'Failed to fetch ProgressTracker settings');
    }
};


